import React from "react";
import { FormattedMessage } from "react-intl";

export function DisplayUserOrganizations({ user }) {
  return user.organizations.map( (organization, index) => {
    if (organization.user_id === user.id) {
      return (
        <div key={`item-${index}`}>
          {`${organization.name} `}(
          <FormattedMessage
            id="components.pages.clients.clientsTable.table.owner"/>
          )
        </div>
      );
    } else {
      return <div key={`item-${index}`}>{`${organization.name}`}</div>;
    }
  } );
}
